export default function initHeaderScroll(): void {
  const header = document.getElementById('site-header') as HTMLElement | null

  let isScrolled = false

  function handleScroll(): void {
    const scrollPosition = window.scrollY || window.pageYOffset
    if (!header) {
      return
    }

    const mobileMenu = document.querySelector('.mobileMenuWrapper')
    const isMobileMenuOpen =
      mobileMenu?.classList.contains('open') ||
      mobileMenu?.classList.contains('active') ||
      document.body.classList.contains('menu-open')

    if (isMobileMenuOpen) {
      if (isScrolled) {
        isScrolled = false
        header.classList.remove('scroll')
        header.classList.add('start')
      }
      return
    }

    if (scrollPosition > 0 && !isScrolled) {
      isScrolled = true
      header.classList.remove('start')
      header.classList.add('scroll')
    } else if (scrollPosition === 0 && isScrolled) {
      isScrolled = false
      header.classList.remove('scroll')
      header.classList.add('start')
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true })

  const observer = new MutationObserver(() => {
    handleScroll()
  })

  const mobileMenu = document.querySelector('.mobileMenuWrapper')
  if (mobileMenu) {
    observer.observe(mobileMenu, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  })

  handleScroll()
}
